var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-2 rounded-circle pa-2 blue",class:{ 'blue-grey': !_vm.is_current, 'darken-4': _vm.is_current },staticStyle:{"width":"6px","height":"6px"}})}
var staticRenderFns = []

export { render, staticRenderFns }